import "./Popup.scss";
import Close from "../../components/icons/Close";

interface Props {
  showPopup: boolean;
  setShowPopup: any;
  children: JSX.Element;
  disableOffClick?: boolean;
  full?: boolean;
  close?: boolean;
}

function Popup(props: Props) {
  let close = true;
  if(props.close === false)
    close=false;
  return (
    <>
    <div
      className={`popup fadeInAndOut ${props.showPopup ? "fadeIn" : "fadeOut"} ${props.full ? "full" : ""}`}
    >
      <div
        className="offclick"
        onClick={() => !props.disableOffClick && props.setShowPopup(false)}
      ></div>
      <div className="holder">
        {close && <div className="close" onClick={() => props.setShowPopup(false)}>
          <Close />
        </div>}
        {props.children}
      </div>
      </div>

      </>
  );
}

export default Popup;
